var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-btn',{staticClass:"cbr-account-btn",attrs:{"loading":_vm.loadingImport,"dark":"","color":_vm.color,"x-small":""},on:{"click":_vm.send}},[_vm._v(_vm._s(_vm.status))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }